// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications-settings-item[data-v-69138136] .toggle label{font-size:1.2rem;color:var(--text-text-secondary)}", ""]);
// Exports
module.exports = exports;
